import {
    STUDENT_GET_PROFILE_REQUEST,
    STUDENT_GET_PROFILE_SUCCESS,
    STUDENT_GET_PROFILE_FAILURE,
    STUDENT_UPDATE_PROFILE_REQUEST,
    STUDENT_UPDATE_PROFILE_SUCCESS,
    STUDENT_UPDATE_PROFILE_FAILURE,
    STUDENT_GET_BOOKINGS_REQUEST,
    STUDENT_GET_BOOKINGS_SUCCESS,
    STUDENT_GET_BOOKINGS_FAILURE,
    STUDENT_GET_ORDERS_REQUEST,
    STUDENT_GET_ORDERS_SUCCESS,
    STUDENT_GET_ORDERS_FAILURE,
    STUDENT_GET_SUBSCRIPTIONS_REQUEST,
    STUDENT_GET_SUBSCRIPTIONS_SUCCESS,
    STUDENT_GET_SUBSCRIPTIONS_FAILURE,
    SET_UTMS,
} from './types';
import { request } from 'cademy-shared-web';

export const getProfile = () => (dispatch) => {
    dispatch({ type: STUDENT_GET_PROFILE_REQUEST });
    request
        .get(`/students/profile?complete=true`)
        .then((res) => {
            dispatch({
                type: STUDENT_GET_PROFILE_SUCCESS,
                payload: res.data,
            });
        })
        .catch((_) => dispatch({ type: STUDENT_GET_PROFILE_FAILURE }));
};

export const updateProfile = (obj) => (dispatch, getState) => {
    dispatch({ type: STUDENT_UPDATE_PROFILE_REQUEST });

    const iam = getState().auth.iam;

    return request
        .post(`/students/profile`, obj)
        .then(({ data }) => {
            dispatch({ type: STUDENT_UPDATE_PROFILE_SUCCESS, payload: data });
            window.analytics.identify(iam.id, {
                location: obj?.address?.city,
                interests: obj?.interests?.category_refs.join(', '),
            });
            return data;
        })
        .catch((err) => {
            dispatch({ type: STUDENT_UPDATE_PROFILE_FAILURE, payload: err });
            throw err;
        });
};

export const getBookings = () => (dispatch) => {
    dispatch({ type: STUDENT_GET_BOOKINGS_REQUEST });
    request
        .get(`/bookings`)
        .then(({ data }) => {
            dispatch({
                type: STUDENT_GET_BOOKINGS_SUCCESS,
                payload: data,
            });
        })
        .catch(() => dispatch({ type: STUDENT_GET_BOOKINGS_FAILURE }));
};

export const getOrders = () => (dispatch) => {
    dispatch({ type: STUDENT_GET_ORDERS_REQUEST });
    request
        .get(`/orders`)
        .then(({ data }) => {
            dispatch({
                type: STUDENT_GET_ORDERS_SUCCESS,
                payload: data.data,
            });
        })
        .catch(() => dispatch({ type: STUDENT_GET_ORDERS_FAILURE }));
};

export const getSubscriptions =
    (handleErrors = true) =>
    (dispatch) => {
        dispatch({ type: STUDENT_GET_SUBSCRIPTIONS_REQUEST });
        request
            .get('/subscriptions', { handleErrors })
            .then(({ data }) => {
                dispatch({
                    type: STUDENT_GET_SUBSCRIPTIONS_SUCCESS,
                    payload: data,
                });
            })
            .catch(() => {
                dispatch({ type: STUDENT_GET_SUBSCRIPTIONS_FAILURE });
            });
    };

export const setUtms = (data) => (dispatch) => {
    dispatch({
        type: SET_UTMS,
        payload: data,
    });
};
